import {normalizeGuestKeySettings} from './propertyGuestKeyModel';

export const PROPERTY_ROOM_FIELDS = ['bedroom', 'bathroom', 'sofabed', 'single', 'queen', 'king'];
export const PROPERTY_TIME_OPTIONS = ['', ...Array.from({length: 15}, (_, index) => `${String(index + 8).padStart(2, '0')}:00`)];
const TEXT_FIELDS = ['full_address', 'cos_customer_name', 'agent_name', 'phone', 'email', 'key_number',
    'check_out', 'description', 'job_type', 'consumable_type', 'air_bnb_ical'];

export function normalizePropertyDetails(property) {
    return {
        property_id: property.property_id,
        ...Object.fromEntries(TEXT_FIELDS.map(field => [field, String(property[field] ?? '')])),
        ...Object.fromEntries(PROPERTY_ROOM_FIELDS.map(field => [field, Number(property[field] ?? 0)])),
        region: property.region || '',
        ...normalizeGuestKeySettings(property),
        checklist_revision: property.checklist_revision,
        checklists: (property.checklists || []).filter(item => item.level === 'PROPERTY').map(item => ({
            id: item.id, description: item.description || '', level: 'PROPERTY', completed: item.completed ?? false,
        })),
    };
}

export function propertyDetailsError(value) {
    if (!value?.full_address?.trim()) return 'Enter a property address.';
    if (!value.job_type) return 'Select a job type.';
    if (!value.check_out) return 'Select a check-out time.';
    if (PROPERTY_ROOM_FIELDS.some(field => value[field] === '' || !Number.isFinite(Number(value[field])) || Number(value[field]) < 0)) {
        return 'Room and bed counts must be zero or a positive number.';
    }
    return '';
}

// Match Manage's property-only update contract; job dates and check-in times belong to individual jobs.
export function propertyDetailsPayload(value) {
    const payload = {
        property_id: value.property_id,
        ...Object.fromEntries(TEXT_FIELDS.map(field => [field, value[field]])),
        ...Object.fromEntries(PROPERTY_ROOM_FIELDS.map(field => [field, Number(value[field])])),
    };
    if (!payload.consumable_type) delete payload.consumable_type;
    if (value.checklist_revision != null) {
        payload.checklist_revision = value.checklist_revision;
        payload.checklists = value.checklists.filter(item => item.description.trim()).map(item => ({
            id: item.id, description: item.description, level: 'PROPERTY', completed: item.completed ?? false,
        }));
    }
    return payload;
}
